var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"enable-background":"new 0 0 24 24"},attrs:{"version":"1.1","id":"レイヤー_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":`${_vm.size}px`,"height":`${_vm.size}px`,"viewBox":"0 0 24 24","xml:space":"preserve"}},[_c('g',{attrs:{"id":"グループ_372","transform":"translate(0.999 1)"}},[_c('path',{staticClass:"st0",style:({
        stroke: _vm.colors[0],
      }),attrs:{"id":"パス_36","d":"M1.4,11v9.9h20V11"}}),_c('path',{staticClass:"st1",style:({
        stroke: _vm.colors[0],
      }),attrs:{"id":"パス_37","d":"M11.4,1.8v13.9"}}),_c('path',{staticClass:"st1",style:({
        stroke: _vm.colors[0],
      }),attrs:{"id":"パス_38","d":"M6.5,10.8l4.9,4.9l4.9-4.9"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }